/// <amd-module name="SuiteCommerce.PagePrinter.Item.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.Item.Collection", ["require", "exports", "underscore", "SuiteCommerce.PagePrinter.Common.Utils", "SuiteCommerce.PagePrinter.Common.Configuration", "Backbone", "SuiteCommerce.PagePrinter.Item.Model"], function (require, exports, _, Utils_1, Configuration_1, Backbone_1, Item_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemCollection = /** @class */ (function (_super) {
        __extends(ItemCollection, _super);
        function ItemCollection(options) {
            var _this = _super.call(this) || this;
            _this.model = Item_Model_1.ItemModel;
            if (options) {
                _this.environment = options.environment;
                _this.ids = options.ids || [];
            }
            return _this;
        }
        Object.defineProperty(ItemCollection.prototype, "url", {
            get: function () {
                return Utils_1.Utils.addParamsToUrl('/api/items', this.getSearchApiParams());
            },
            enumerable: true,
            configurable: true
        });
        ItemCollection.prototype.getSearchApiParams = function () {
            var searchApiParams = _({}).extend(this.getSearchApiMasterOptions(), this.getSessionSearchApiParams());
            if (this.ids.length > 0) {
                searchApiParams = _(searchApiParams).extend(this.getItemsParams());
            }
            return searchApiParams;
        };
        ItemCollection.prototype.getSearchApiMasterOptions = function () {
            return Configuration_1.Configuration.get('searchApiMasterOptions.itemDetails', {});
        };
        ItemCollection.prototype.getSessionSearchApiParams = function () {
            var searchApiParams = {};
            var sessionInfo = this.environment.getSession();
            var locale = (sessionInfo.language && sessionInfo.language.locale) || '';
            var language = '';
            var country = '';
            var currency = (sessionInfo.currency && sessionInfo.currency.code) || '';
            var priceLevel = sessionInfo.priceLevel || '';
            var localeTokens;
            if (locale.indexOf('_') >= 0) {
                localeTokens = locale.split('_');
                language = localeTokens[0];
                country = localeTokens[1];
            }
            else {
                language = locale;
            }
            if (language) {
                searchApiParams.language = language;
            }
            if (country) {
                searchApiParams.country = country;
            }
            if (currency) {
                searchApiParams.currency = currency;
            }
            searchApiParams.pricelevel = priceLevel;
            if (Utils_1.Utils.parseUrlOptions(window.location.search).nocache === 'T') {
                searchApiParams.nocache = 'T';
            }
            return searchApiParams;
        };
        ItemCollection.prototype.getItemsParams = function () {
            return {
                id: this.ids.join(','),
            };
        };
        ItemCollection.prototype.parse = function (response) {
            return _(response.items).compact() || null;
        };
        return ItemCollection;
    }(Backbone_1.Collection));
    exports.ItemCollection = ItemCollection;
});
